// extracted by mini-css-extract-plugin
export var logo = "CardLogo-module--logo--3hD1B";
export var logoImage = "CardLogo-module--logoImage--2Rvvt";